import { formatNumericValue } from 'utils/general';

import { IReconciliation } from '@/modules/workingDayReconciliation/types';
// TODO: currency
export const getCardData = ({
  data,
  currency,
}: {
  data: IReconciliation.IGetWorkdaySummary;
  currency: string;
}): IReconciliation.IReconciliationCardInfo => {
  const {
    issuedPayment,
    supplierName,
    totalAdministrativeBonusess,
    totalAdministrativeDeduction,
    totalHoursBonusess,
    totalNetPayment,
    totalSupervisionDeductions,
    totalSupervisionBonusess,
    totalWorkers,
  } = data;
  return {
    team_leader: supplierName,
    attendanceNumber: totalWorkers ? formatNumericValue(totalWorkers) : '-',
    supervisionDeduction: totalSupervisionDeductions
      ? `${formatNumericValue(totalSupervisionDeductions)} ${currency || ''}`
      : '-',
    managerialDeduction: totalAdministrativeDeduction
      ? `${formatNumericValue(totalAdministrativeDeduction)} ${currency || ''}`
      : '-',
    supervisionBonuses: totalSupervisionBonusess
      ? `${formatNumericValue(totalSupervisionBonusess)} ${currency || ''}`
      : '-',
    bonusesHours: totalHoursBonusess
      ? `${formatNumericValue(totalHoursBonusess)} ${currency || ''}`
      : '-',
    administrativeIncentives: totalAdministrativeBonusess
      ? `${formatNumericValue(totalAdministrativeBonusess)} ${currency || ''}`
      : '-',
    netDues: totalNetPayment
      ? `${formatNumericValue(totalNetPayment)} ${currency || ''}`
      : '-',
    // In Case Issued payment is less than Net Payment  it should be displayed by orange color and info icon when user hover on this icon, it should display message يوجد مستحقات لم يتم إصدارها بمستخلص
    // In Case the Issued payment is equal to the Net Payment, it should be displayed by green color
    // In case the Issued payment equal 0 should view input ----
    issuedReceivables: {
      text: issuedPayment
        ? `${formatNumericValue(issuedPayment)} ${currency || ''}`
        : '----',
      status:
        issuedPayment === 0 ? 0 : issuedPayment == totalNetPayment ? 1 : 2,
    },
  };
};
